import './DownLoad.css';
import pic1 from '../image/pic1.jpg'
import {Component} from "react";
import {showToast} from "../utils/methods";

class downLoad extends Component {
    pressDownload(){
        showToast('Coming soon!')
    }
    render() {
        return (
            <div className="downLoad">
                <img className='download-background' alt='error-img' src={pic1}/>
                <div className={'download-bg-mask'}></div>
                <div className='download-container'>
                    <div className='download-words'>Your first step to online freedom</div>
                    <button className="downLoad-button" id='download' onClick={this.pressDownload.bind(this)}>DownLoad</button>
                </div>
            </div>
        );
    }
}


export default downLoad